import { z } from 'zod';

/** The body of `GET /alive` (SCF-D1). */
export const envTypeSchema = z.enum(['dev', 'live', 'local']);
export type EnvType = z.infer<typeof envTypeSchema>;

export const aliveResponseSchema = z
  .object({
    buildNumber: z.string().min(1),
    envType: envTypeSchema,
  })
  .strip();
export type AliveResponse = z.infer<typeof aliveResponseSchema>;
